{
  "version": 1,
  "asset_id": "42985f9a-949b-46f9-a897-7f90e72b5185",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/42985f9a-949b-46f9-a897-7f90e72b5185/gallery-5.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/42985f9a-949b-46f9-a897-7f90e72b5185/gallery-5.jpeg",
  "original_filename": "gallery-5.jpeg",
  "size": 874146,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:36Z"
}
